import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// import MobileEmailFooter from './MobileEmailFooter';

interface NavLinkItemProps {
    to: string;
    text: string;
    isPhotographsPage: boolean;
}

const NavLinkItem: React.FC<NavLinkItemProps> = ({ to, text, isPhotographsPage }) => (
  <NavLink 
    to={to}
    className={({ isActive }) => 
      `transition-opacity duration-500 whitespace-nowrap ${
        isActive 
          ? 'opacity-100'
          : 'opacity-50 hover:opacity-100'
      } ${
        isPhotographsPage ? 'text-black' : 'text-white'
      }`
    }
  >
    {text}
  </NavLink>
);

const Nav: React.FC = () => {
    const location = useLocation();
    const isPhotographsPage = location.pathname === '/photographs';
    const [isBgVisible, setIsBgVisible] = useState(false);

    // Handle scroll event
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 160) {
                setIsBgVisible(true);
            } else {
                setIsBgVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Reset scroll position on route change
    useEffect(() => {
        window.scrollTo(0, 0);
        setIsBgVisible(false); // Reset background visibility on route change
    }, [location.pathname]);

    return (
        <div className="sticky top-0 z-10 pl-4 pr-0 py-3">
            {/* Background with fade-in effect */}
            <div className={`absolute inset-0 ${
                isPhotographsPage ? 'bg-white/80' : 'bg-black/80'
            } transition-opacity duration-500 delay-0 ${
                isBgVisible ? 'opacity-100' : 'opacity-0'
            }`}></div>

            {/* Nav links */}
            <div className="relative z-10 flex justify-start gap-x-2 overflow-x-auto whitespace-nowrap scrollbar-hide">
                <NavLinkItem to="/" text="Home," isPhotographsPage={isPhotographsPage} />
                <NavLinkItem to="/about" text="About," isPhotographsPage={isPhotographsPage} />
                <NavLinkItem to="/photographs" text="Photo," isPhotographsPage={isPhotographsPage} />
                <NavLinkItem to="/explore" text="Explore," isPhotographsPage={isPhotographsPage} />
                <a 
                    href="mailto:taylor@taylorpemberton.com" 
                    className={`transition-opacity duration-500 whitespace-nowrap ${
                        isPhotographsPage ? 'text-black opacity-50 hover:opacity-100' : 'text-white opacity-50 hover:opacity-100'
                    }`}
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    Email<span className="md:hidden">,</span>
                </a>
                {/* <button
                  type="button"
                  className={`md:hidden transition-opacity duration-500 whitespace-nowrap ${
                    isPhotographsPage ? 'text-black opacity-50 hover:opacity-100' : 'text-white opacity-50 hover:opacity-100'
                  }`}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                  onClick={() => setShowMobileEmailFooter && setShowMobileEmailFooter(true)}
                >
                  Subscribe
                </button> */}
                {/* Temporarily hidden
                <a 
                    href="https://instagram.com/pemberton" 
                    className={`transition-opacity duration-500 whitespace-nowrap ${
                        isPhotographsPage ? 'text-black opacity-50 hover:opacity-100' : 'text-white opacity-50 hover:opacity-100'
                    }`}
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    Instagram,
                </a>
                <a 
                    href="https://twitter.com/pemberton" 
                    className={`transition-opacity duration-500 whitespace-nowrap ${
                        isPhotographsPage ? 'text-black opacity-50 hover:opacity-100' : 'text-white opacity-50 hover:opacity-100'
                    }`}
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    Twitter
                </a>
                */}
            </div>
            {/* {showMobileEmailFooter && (
              <MobileEmailFooter active={showMobileEmailFooter} />
            )} */}
        </div>
    );
};

export default Nav;

export const experienceData = [
  {
    company: "Superset",
    role: "CEO & Co-Founder",
    duration: "2020 - Present",
    points: [
      "Building platform for 900,000+ online health/fitness professionals managing $40B/year",
      // ... other points
    ]
  },
  // ... other experience items
]; 